import type { ReactNode } from "react"
import Dialog from "@/v2-ui/dialog"
import cn from "@/v2-ui/utils/utils.cn"

export type ManageDialogProps = {
  open: boolean
  onOpenChange(open: boolean): void
  title: ReactNode
  className?: string
  children: ReactNode
}

function ManageDialog(props: ManageDialogProps) {
  const { open, onOpenChange, title, className, children } = props

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Content
        className={cn("manage-dialog-content", className)}
        align="top"
      >
        <Dialog.Header className="manage-dialog-header">
          <Dialog.Title>{title}</Dialog.Title>
        </Dialog.Header>
        {children}
      </Dialog.Content>
    </Dialog>
  )
}

export default ManageDialog
